import ja from '../../resources/locales/ja-JP.json';
export default {
  ...ja,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['ja-JP'],
};
